import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M136 32H24C10.75 32 0 42.75 0 56v112c0 13.3 10.75 24 24 24 13.26 0 24-10.7 24-24V80h88c13.3 0 24-10.75 24-24s-10.7-24-24-24m288 0H312c-13.3 0-24 10.75-24 24 0 13.26 10.75 24 24 24h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.25-10.7-24-24-24M136 432H48v-88c0-13.3-10.75-24-24-24S0 330.7 0 344v112c0 13.3 10.75 24 24 24h112c13.3 0 24-10.7 24-24s-10.7-24-24-24m288-112c-13.26 0-24 10.75-24 24v88h-88c-13.26 0-24 10.75-24 24s10.7 24 24 24h112c13.25 0 24-10.75 24-24V344c0-13.3-10.7-24-24-24",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1)
  ])))
}
export default { render: render }